var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@mui/material';
import { AiOutlineReload } from 'react-icons/ai';
import { FlexGrowCol } from '../FlexBox';
import ErrorViewer from './ErrorViewer';
const ErrorsViewer = (props) => {
    const { onRetry, errors } = props, boxProps = __rest(props, ["onRetry", "errors"]);
    return (_jsxs(FlexGrowCol, Object.assign({ padding: 1 }, boxProps, { children: [errors === null || errors === void 0 ? void 0 : errors.map((error, index) => {
                return _jsx(ErrorViewer, { error: error }, index);
            }), onRetry ? (_jsx(IconButton, Object.assign({ onClick: onRetry }, { children: _jsx(AiOutlineReload, {}, void 0) }), void 0)) : null] }), void 0));
};
export default ErrorsViewer;
//# sourceMappingURL=ErrorsViewer.js.map